import { useMemo } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import WhySection from "./components/WhySection";
import HowSection from "./components/HowSection";
import CompareSection from "./components/CompareSection";
import SafetySection from "./components/SafetySection";
import ArticleSection from "./components/ArticleSection";
import FaqSection from "./components/FaqSection";
import CtaBar from "./components/CtaBar";
import { useJsonLd } from "@/hooks/useJsonLd";
import { getSiteUrl } from "@/utils/seo";
import { faqData } from "@/mocks/faq";

export default function Home() {
  const siteUrl = getSiteUrl();

  const homepageJsonLd = useMemo(() => ({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        name: "Kakobuy Spreadsheet Polska",
        url: siteUrl,
        description:
          "Największa polska baza produktów Kakobuy Spreadsheet – znajdź najlepsze produkty, poradniki i listy zakupowe.",
        inLanguage: "pl-PL",
        publisher: {
          "@type": "Organization",
          name: "Kakobuy Spreadsheet Polska",
          url: siteUrl,
        },
      },
      {
        "@type": "Organization",
        name: "Kakobuy Spreadsheet Polska",
        url: siteUrl,
        description:
          "Największa polska baza produktów Kakobuy Spreadsheet – poradniki, listy produktów i bezpieczne zakupy.",
      },
      {
        "@type": "FAQPage",
        mainEntity: faqData.map((faq) => ({
          "@type": "Question",
          name: faq.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: faq.answer,
          },
        })),
      },
    ],
  }), [siteUrl]);

  useJsonLd(homepageJsonLd);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <WhySection />
        <HowSection />
        <CompareSection />
        <SafetySection />
        <ArticleSection />
        <FaqSection />
        <CtaBar />
      </main>
      <Footer />
    </div>
  );
}